import { observable, computed, action, makeObservable } from 'mobx';

class SuggestionsStore {
    isOpen;
    flagDialogTitle;
    suggestion;
    selectedTab;
    prevSuggestions;
    suggestions;
    suggestionId;
    newFlag;
    isCommentDialogOpen;
    callback;

    constructor() {
       
        this.isOpen = false;
        this.isCommentDialogOpen = false;
        this.selectedTab = 0;
        this.suggestion = { description: '', sessionId: this.uuidv4() };
        this.prevSuggestions = [];
        this.suggestions = [];
        this.flagDialogTitle = '';
        this.suggestionId = '';
        this.newFlag = false;
        this.callback = () => { };

        makeObservable(this, {
            isOpen: observable,
            callback: observable,
            suggestionId: observable,
            newFlag: observable,
            flagDialogTitle: observable,
            isCommentDialogOpen: observable,
            suggestion: observable,
            suggestions: observable,
            selectedTab: observable,
            getSuggestionId: computed,
            isSuggestionDialogOpen: computed,
            getSelectedTab: computed,
            getFlagDialogTitle: computed,
            getIsCommentDialogOpen: computed,
            getSuggestions: computed,
            getSuggestion: computed,
            closeSuggestionDialog: action,
            openSuggestionDialog: action,
            setSelectedTab: action,
            openCommenDialog: action,
            closeCommentDialog: action,
            setSuggestion: action,
            updateSuggestion: action,
            setCallback: action,
            setSuggestions: action
        });
    }

    get isSuggestionDialogOpen() {
        return this.isOpen;
    }

    get getSuggestion() {
        return this.suggestion;
    }

    get getSuggestions() {
        return this.suggestions;
    }

    get getSelectedTab() {
        return this.selectedTab;
    }

    setSuggestion(suggestion) {
        this.suggestion = suggestion;
    }

    setSuggestions(suggestions) {
        this.suggestions = suggestions;
    }

    updateSuggestion(suggestion) {
        //var suggestions = this.suggestions.slice(0);

        if (!suggestion.id) {
            this.suggestions.push(suggestion);
        }
        else {
            //var suggestions = this.suggestions.slice(0);
            var index = this.suggestions.findIndex(w => w.id === suggestion.id);
            if (index > -1) {
                //this.suggestions.splice(index, 1);
                //var newPosition = this.suggestions.filter(w => w.position < suggestion.position).length;
                this.suggestions.splice(index, 1, suggestion);
                //this.suggestions = suggestions.sort(this.sort);
            }
            else {
                this.suggestions.push(suggestion);
            }
        }

        //this.suggestions = suggestions;
    }

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    setSelectedTab(selectedTab) {
        this.selectedTab = selectedTab;
    }

    get getIsCommentDialogOpen() {
        return this.isCommentDialogOpen;
    }

    get getFlagDialogTitle() {
        return this.flagDialogTitle;
    }

    get getSuggestionId() {
        return this.suggestionId;
    }

    openCommenDialog(title, suggestionId, newFlag) {
        this.isCommentDialogOpen = true;
        this.flagDialogTitle = title;
        this.suggestionId = suggestionId;
        this.newFlag = newFlag;
    }

    closeCommentDialog() {
        this.isCommentDialogOpen = false;
    }

    openSuggestionDialog(suggestion, callback) {
        if (this.suggestion.id) {
            this.prevSuggestions.push(this.suggestion);
        }
        this.suggestion = suggestion;
        this.isOpen = true;
        this.selectedTab = 0;
        this.callback = callback;
    }

    setCallback(callback) {
        this.callback = callback;
    }

    closeSuggestionDialog() {
        
        if (this.prevSuggestions.length > 0) {
            this.suggestion = this.prevSuggestions.pop();
        }
        else {
            this.suggestion = { text: '', sessionId: this.uuidv4() };
            this.isOpen = false;
        }
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

const suggestionsStore = new SuggestionsStore();

export default suggestionsStore;
export { SuggestionsStore };